<template>
  <div class="chat-page">
    <MobileNav :page_title="nav_title" v-if="screenOuterSize > 880 || (screenOuterSize < 880 && !showChatWindow)"></MobileNav>
    <div :class="[isChatDesktopView ? 'chat-desktop-view' : 'chat-mobile-view']">
      <ChatListSideBar v-if="userType && showSideBar" :loggedInUserType="userType" @userSelected="selectUserFromSideBar" @changeStatus="changeStatus" @sendDownloadEvent="sendDownloadEvent" @setupChatSessionTimer="setupChatSessionTimer" ref="chatListSideBar" />

      <ChatWindow
        v-if="selectedUser && Object.keys(selectedUser).length && showChatWindow"
        @isFeedbackPopupVisible="checkFeedbackPopupVisibility"
        @backToExpertList="
          showChatWindow = false;
          showSideBar = true;
        "
        :selectedUser="selectedUser"
        :loggedInUserType="userType"
        ref="chatWindow"
      />
      <!-- @sessionExpired="markSessionExpired" -->

      <div v-else-if="isChatDesktopView" class="chat-placeholder">
        <img src="../assets/images/ChatImages/undraw_group_chat_re_frmo 1.svg" alt="" />
      </div>
    </div>

    <div class="feedback-popup-outer">
      <el-dialog :visible.sync="feedbackPopupVisible" class="feedback-popup feedback-one" :show-close="false" :close-on-click-modal="false">
        <div class="popup-content">
          <!-- Title and Partition Line -->
          <h3 class="popup-title">Did you get the market insights you were looking for?</h3>
          <p class="sub-title">Your valuable feedback will help us deliver a better experience</p>

          <!-- Buttons (Beginner, Investor, Trader) -->
          <div class="button-group">
            <button class="category-btn no" size="large" :class="{ active: selectedFeedback === 'No' }" @click="selectFeedback('No')">No</button>
            <button class="category-btn yes" size="large" :class="{ active: selectedFeedback === 'Yes' }" @click="selectFeedback('Yes')">Yes</button>
            <button class="category-btn partially" size="large" :class="{ active: selectedFeedback === 'Partially' }" @click="selectFeedback('Partially')">Partially</button>
          </div>

          <div class="flex-center flex-wrap top-margin-20">
            <div v-for="option in selectedReviewsOptions" class="review-options" @click="toggleOption(option)" :class="{ selected: finalReviewOptions.includes(option) }">{{ option }}</div>
          </div>
          <el-button class="chat-btn top-margin-20" @click="submitReview()" :disabled="selectedFeedback == '' || !finalReviewOptions.length">Submit</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="goToExpertListPopupVisible" class="feedback-popup feedback-two" :show-close="false">
        <!-- <i class="el-icon-error cursor-pointer" @click="feedbackPopupVisible = false"></i> -->
        <img src="../assets/images/closeIcon.svg" class="close-icon cursor-pointer" @click="goToExpertListPopupVisible = false" />
        <div class="popup-content">
          <!-- Title and Partition Line -->
          <h3 class="popup-title">Would you like to explore the Expert List?</h3>
          <!-- <p class="sub-title">Your valuable feedback will help us deliver a better experience</p> -->

          <!-- Buttons (Beginner, Investor, Trader) -->
          <div class="button-group top-margin-25">
            <button class="category-btn yes" size="mini" @click="goToExpertChat('Yes')">Yes</button>
            <button class="category-btn partially" size="mini" @click="goToExpertChat('No')">Stay here</button>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="chat-ended-popup-outer">
      <el-dialog :visible.sync="chatEndedPopupVisible" class="feedback-popup" :show-close="false">
        <div class="popup-content">
          <!-- Title and Partition Line -->
          <h3 class="popup-title">This chat has been ended</h3>

          <el-button class="btn-light-blue-filled" style="width: 100px" @click="chatEndedPopupVisible = false">Close</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="ra-agreement-popup-outer">
      <el-dialog :visible.sync="RaAgreementPopupVisible" class="feedback-popup" :show-close="false" :close-on-click-modal="false">
        <div class="popup-content">
          <!-- Title and Partition Line -->
          <h3 class="popup-title">SEBI Experts have the following duties and responsibilities:</h3>

          <ul>
            <li>
              <span>Market Analysis:</span>
              Provide insights on IPOs, general market trends, and news impact.
            </li>
            <li>
              <span>Research and Reports:</span>
              Share research reports and technical chart analysis.
            </li>
            <li>
              <span>Advisory Limits:</span>
              Refrain from one-on-one consultancy, direct investment advice, portfolio creation, health checks, or rebalancing services.
            </li>
          </ul>

          <p>Experts focus on delivering general market perspectives without specific stock recommendations.</p>
          <p>If retail investors ask for target prices on stocks, options, ETFs, or indices, providing them is allowed. Provided the targets are supported with relevant research, logical reasoning, charts, and reports.</p>
          <div class="text-center">
            <el-button class="btn-light-blue-filled" style="width: 100px" @click="startChat()" :loading="requestLoader">I agree</el-button>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="non-active-ra-popup">
      <el-dialog :visible.sync="nonActiveRaPopupVisible" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true" @close="$router.push('/experts-past-recommendations')" center>
        <div class="title">Unlock StockAnts Chat Today!</div>

        <div class="sub-text">
          Reach us at
          <a class="mail" href="mailto:admin@stockants.com?subject=Subject Here&body=Hello, I am interested in your service.">admin@stockants.com</a>
          to get access of StockAnts Chat
        </div>
        <div class="list">
          <ul>
            <li>
              <img src="../assets/images/GreenTick.svg" alt="" />
              Direct Engagement with Investors
            </li>
            <li>
              <img src="../assets/images/GreenTick.svg" alt="" />
              Enhanced Professional Profile
            </li>
            <li>
              <img src="../assets/images/GreenTick.svg" alt="" />
              Increased Revenue Opportunities
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>

    <!-- new chat request dialog -->
    <el-dialog :visible.sync="newChatRequestDialogVisible" class="feedback-popup feedback-two" :show-close="false" :close-on-click-modal="false">
      <div class="popup-content">
        <!-- <div>New Chat Request from {{ newChatRequestObj.second_user_details ? newChatRequestObj.second_user_details.full_name : 'User' }}</div> -->
<div>New Chat Request from {{ newChatRequestObj && newChatRequestObj.second_user_details ? newChatRequestObj.second_user_details.full_name : 'User' }}</div>

        <div class="top-margin-10">
          <el-button class="btn-light-blue-filled" style="width: 100px" @click="acceptChatRequestDialog">Accept</el-button>
          <el-button class="btn-light-blue-filled" style="width: 100px" @click="denyChatRequestDialog" :loading="isRequestCanceling">Deny</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MobileNav from '@/components/MobileNav.vue';
import ChatListSideBar from '@/components/ChatListSideBar.vue';
import ChatWindow from '@/components/ChatWindow.vue';
import { serverAddr } from '../networkConfig';
import { screenSize } from '../mixins/ScreenSize.js';
// import socket from '../mixins/WebSocket.js';
import CripNotice from 'crip-vue-notice';
import { ChatTimer } from '../mixins/ChatTimer.js';

export default {
  components: {
    MobileNav,
    ChatListSideBar,
    ChatWindow,
  },

  mixins: [screenSize, ChatTimer],

  data() {
    return {
      nav_title: 'Expert Chat',
      selectedUser: null,
      feedbackPopupVisible: false,
      chatEndedPopupVisible: false,
      nonActiveRaPopupVisible: false,
      RaAgreementPopupVisible: false,
      selectedFeedback: '',
      userType: '',
      showSideBar: false,
      showChatWindow: false,
      goToExpertListPopupVisible: false,
      yesReviewOptionsList: ['Very insightful', 'Clear and concise', 'Helpful advice', 'Highly knowledgeable', 'Quick and to the point', 'Great guidance', 'Professional approach', 'Easy to understand', 'Patient and thorough', 'Exceeded expectations', 'Would consult again'],
      noReviewOptionsList: ['Poor explanation', 'Advice was not useful', 'Incomplete responses', 'Lack of expertise', 'Too generic', 'Unclear communication', 'Took too long to respond', 'Did not answer my queries', 'Inconsistent information', 'Would not consult again'],
      partialReviewOptionsList: ['Some advice was helpful', 'Needed more details', 'Could be clearer', 'Too brief', 'Some responses were vague', 'More in-depth analysis required', 'Missed some of my questions', 'Communication could improve', 'Not entirely relevant to my query', 'Might consult again with improvements'],
      selectedReviewsOptions: [],
      finalReviewOptions: [],
      requestLoader: false,
      isRequestCanceling: false,
      recentUsers: [],
      newChatRequestDialogVisible: false,
      isBackButtonPressed: false,
    };
  },

  watch: {
    screenOuterSize(oldValue, newValue) {
      if (newValue < 880) {
        this.showSideBar = this.showChatWindow = true;
      } else {
        this.showSideBar = true;
        this.showChatWindow = false;
      }
    },
  },

  created() {
    if (this.isChatDesktopView) {
      this.showSideBar = this.showChatWindow = true;
    } else {
      this.showSideBar = true;
      this.showChatWindow = false;
    }
  },

  mounted() {
    if (localStorage.getItem('hasUserRoomJoinedRoom')) {
      console.log('page reloaded and user has already joined room');
      localStorage.removeItem('hasUserRoomJoinedRoom');
    }

    this.$socket.off('recent-chat'); // Remove previous listeners to prevent duplication

    this.$socket.emit('get_recent_chat', { user_id: this.userProfile.id }, (ack) => {
      // console.log('Acknowledgment:', ack);
    });

    this.$socket.on('recent-chat', (data) => {
      // if (data.login_user_id == this.userProfile.id) {
      console.log('recent-chat', data);

      this.recentUsers = [];

      if (data.data.length) {
        for (let i = 0; i < data.data.length; i++) {
          this.recentUsers.push(data.data[i]);
        }

        this.$store.commit('commitRecentUsers', this.recentUsers);

        let filteredRequestedUser = this.recentUsers.find((e) => e.status_str === 'Requested');

        if (filteredRequestedUser) {
          this.$store.commit('commitRoomId', filteredRequestedUser.title);

          if (this.userType == 'Active RA' || this.userType == 'Non Active RA') {
            this.$store.commit('commitNewChatRequestObj', filteredRequestedUser);
            this.newChatRequestDialogVisible = true;
            // this.$store.commit('commitNewChatRequestDialogState', true);
          }
        } else {
          this.$store.commit('commitNewChatRequestObj', {});
          // this.$store.commit('commitNewChatRequestDialogState', false);
          this.newChatRequestDialogVisible = false;
        }

        if (this.roomId && this.selectedUser && Object.keys(this.selectedUser).length) {
          this.selectedUser = this.recentUsers.find((e) => this.roomId == e.title);
        }

        let filteredOngoingUser = this.recentUsers.find((e) => e.status_str === 'Ongoing');

        if (filteredOngoingUser && (!this.selectedUser || this.selectedUser == null || !Object.keys(this.selectedUser).length)) {
          console.log('onGoingUser but not selected from sidebar', filteredOngoingUser);

          if (!localStorage.getItem('hasUserRoomJoinedRoom')) {
            console.log('user has not joined room');

            this.selectUserFromSideBar(filteredOngoingUser);
            localStorage.setItem('hasUserRoomJoinedRoom', true);
          }
        } else if (filteredOngoingUser && this.selectedUser && Object.keys(this.selectedUser).length) {
          console.log('onGoingUser and selected from sidebar', filteredOngoingUser);
          this.$store.commit('commitSelectedUserForChatObj', filteredOngoingUser);

          this.storeUserChatSessionDetails(filteredOngoingUser);
          // }
        } else {
          console.log('no onGoingUser', this.selectedUser);
          if (this.selectedUser && Object.keys(this.selectedUser).length) {
            this.storeUserChatSessionDetails(this.selectedUser);
          }
        }

        if (filteredOngoingUser || (this.selectedUser && Object.keys(this.selectedUser).length)) {
          // this.$emit('setupChatSessionTimer');
          this.startTimer();
        }
      }
      // }
    });

    if (localStorage.getItem('profile')) {
      this.setUserTypeForChat();
    }
  },

  methods: {
    storeUserChatSessionDetails(user) {
      if (user && user.retail_user_session != null) {
        this.$store.commit('commitRoomId', user.title);
        this.$store.commit('commitUserChatSessionDetails', user.retail_user_session);
        localStorage.setItem('userChatSession', JSON.stringify(user.retail_user_session));
      }
    },

    submitReview() {
      let obj = {
        user_id: this.userProfile.id,
        session_id: this.selectedUser.retail_user_session_id,
        userLikeExperience: this.selectedFeedback,
        reviewOptions: this.finalReviewOptions,
      };
      console.log('Review Object', obj);
      this.$socket.emit('save_session_review', obj, (response) => {
        console.log('Server response received:', response);
        this.feedbackPopupVisible = false;
        // this.goToExpertListPopupVisible = true;

        new CripNotice({
          title: 'Success',
          description: 'Thank you for your valuable feedback! We appreciate your input.',
          type: 'success',
          duration: 3,
        });

        if (!response) {
          console.error('No response received from server!');
        }

        this.backToExpertList();
      });
    },

    toggleOption(option) {
      const index = this.finalReviewOptions.indexOf(option);
      if (index === -1) {
        this.finalReviewOptions.push(option); // Add if not present
      } else {
        this.finalReviewOptions.splice(index, 1); // Remove if already selected
      }
    },

    goToExpertChat(action) {
      if (action == 'Yes') {
        this.goToExpertListPopupVisible = false;
        this.$router.push('/expert-list');
      } else {
        this.goToExpertListPopupVisible = false;
      }
    },

    checkFeedbackPopupVisibility(value) {
      this.feedbackPopupVisible = value;
    },

    setUserTypeForChat() {
      if (this.userProfile.profession == 'Retail Investor') {
        this.userType = 'Retail Investor';
      } else if (this.userProfile.chat_profile_info?.is_active_chat_ra) {
        this.userType = 'Active RA';
      } else if (!this.userProfile.chat_profile_info?.is_active_chat_ra) {
        this.userType = 'Non Active RA';
        this.nonActiveRaPopupVisible = true;
      }
    },

    selectFeedback(feedback) {
      this.selectedFeedback = feedback;
      this.finalReviewOptions = [];

      if (feedback == 'Yes') {
        this.selectedReviewsOptions = this.yesReviewOptionsList;
      } else if (feedback == 'No') {
        this.selectedReviewsOptions = this.noReviewOptionsList;
      } else if (feedback == 'Partially') {
        this.selectedReviewsOptions = this.partialReviewOptionsList;
      }
    },

    // markSessionExpired(roomId) {
    //   console.log('marked session expired');
    //   let recentUsers = this.$refs.chatListSideBar.recentUsers;

    //   for (let i = 0; i < recentUsers.length; i++) {
    //     if (recentUsers[i].title == roomId) {
    //       this.$set(recentUsers[i], 'status_str', 'Completed');
    //     }
    //   }
    // },

    backToExpertList() {
      this.showChatWindow = false;
      this.showSideBar = true;

      this.isBackButtonPressed = true;
    },

    selectUserFromSideBar(user) {
      console.log('selectUserFromSideBar', user);
      try {
        this.storeUserChatSessionDetails(user);
        this.$store.commit('commitSelectedUserForChatObj', user);
        this.selectedUser = user;

        if (!this.isChatDesktopView) {
          if (this.isBackButtonPressed) {
            this.showSideBar = true;
            this.showChatWindow = false;
          } else {
            this.showSideBar = false;
            this.showChatWindow = true;
          }
        } else {
          this.showSideBar = true;
          this.showChatWindow = true;
        }

        this.isBackButtonPressed = false;

        setTimeout(() => {
          // console.log("selected user from side panel", user, this.$refs.chatWindow);
          if (user && user.title) {
            if (user.status_str == 'Ongoing' || user.status_str == 'Requested') {
              console.log('accepting request', this.roomId);
              // this.$store.commit('commitRoomId', user.title);

              localStorage.setItem('isSessionOngoing', true);

              this.$refs.chatWindow.joinRoom(user.title, user.status_str);
            } else {
              console.log('no request needed');
              this.$refs.chatWindow.getRoomMessages(user.title);
            }
          } else {
            console.log('No room details present');
            this.$refs.chatWindow.messages = [];
            this.showChatWindow = false;
          }
        }, 0);

        // let roomIdData = await this.getRoomId();

        // if (roomIdData.data.data && roomIdData.data.status) {
        //   this.$store.commit("commitRoomId", roomIdData.data.data.room_name);
        //   this.$refs.chatWindow.joinRoom(roomIdData.data.data.room_name);
        // } else {
        //   console.log("No room details present");
        //   this.$refs.chatWindow.messages = [];
        //   this.showChatWindow = false;
        // }
      } catch (e) {
        console.log('Error in getting room details', e);
      }
    },

    getRoomId() {
      return serverAddr.post('chat/v1/room', { user_id: this.userProfile.id }).then((response) => {
        console.log('getRoomIds', response);
        return response;
      });
    },

    async changeStatus(status) {
      await this.$socket.emit('update_user_status', { user_id: this.userProfile.id, status: status ? 'Online' : 'Offline' });
    },

    sendDownloadEvent() {
      try {
        setTimeout(() => {
          if (this.$refs.chatWindow.messages && this.$refs.chatWindow.messages.length) {
            let messages = [];

            this.$refs.chatWindow.messages.forEach((msg) => {
              let obj = {
                message: msg.message,
                time: new Date(msg.time).toLocaleString(),
                user: msg.sender_id == this.userProfile.id ? this.userProfile.full_name : this.selectedUser ? this.selectedUser.second_user_details.full_name : '',
              };

              messages.push(obj);
            });

            let fileName = 'chat_messages.json';

            if (this.userProfile.full_name && this.selectedUser.second_user_details.full_name) {
              fileName = `${this.userProfile.full_name}_and_${this.selectedUser.second_user_details.full_name}_chat_messages.json`;
            }

            const blob = new Blob([JSON.stringify(messages, null, 2)], { type: 'application/json' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(link.href);
          }
        }, 0);
      } catch (e) {
        console.log('error in downloading file', e);
      }
    },

    acceptChatRequestDialog() {
      this.newChatRequestDialogVisible = false;
      this.RaAgreementPopupVisible = true;

      // return new Promise((resolve, reject) => {
      //   this.$socket.emit('join_room', { room: this.roomId, user_id: this.userProfile.id }, (ack) => {
      //     console.log('Acknowledgment join_room', ack);

      //     this.$store.commit('commitNewChatRequestDialogState', false);

      //     this.$store.commit('commitRoomId', this.newChatRequestObj.title);

      //     localStorage.setItem('isSessionOngoing', true);

      //     resolve(ack); // Resolve the promise with acknowledgment data

      //     this.requestLoader  = false;
      //   });
      // });

      // this.$store.commit("commitRoomId", this.newChatRequestObj.title);
      // this.selectUserFromSideBar(this.newChatRequestObj);

      // setTimeout(() => {

      // this.$socket.emit('join_room', { room: this.roomId, user_id: this.userProfile.id });

      // this.$refs.chatWindow.joinRoom(this.newChatRequestObj.title);
      // }, 0);

      // this.$refs.chatListSideBar.selectUser(this.newChatRequestObj);
    },
    startChat() {
      this.requestLoader = true;
      this.RaAgreementPopupVisible = false;
      setTimeout(() => {
        this.selectUserFromSideBar(this.newChatRequestObj);
        // this.$refs.chatListSideBar.selectUser(this.newChatRequestObj);
      }, 0);
      this.requestLoader = false;
    },

    denyChatRequestDialog() {
      this.isRequestCanceling = true;
      return new Promise((resolve, reject) => {
        this.$socket.emit('cancel_room_status', { room: this.newChatRequestObj.title, user_id: this.newChatRequestObj.retail_user_id });

        resolve(true); // Resolve the promise with acknowledgment data

        this.newChatRequestDialogVisible = false;
        this.isRequestCanceling = false;
      });

      // this.$store.commit('commitNewChatRequestDialogState', false);
    },

    setupChatSessionTimer() {
      this.startTimer();
    },
  },

  computed: {
    roomId() {
      return this.$store.state.room_id;
    },

    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    // newChatRequestDialogVisible() {
    //   return this.$store.state.newChatRequestDialogVisible;
    // },

    newChatRequestObj() {
      return this.$store.state.newChatRequestObj;
    },

    // selectedUserForChat() {
    //   return this.$store.state.selectedUserForChat;
    // }
  },
};
</script>

<style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.chat-page {
  display: flex;
  height: 100vh;
  overflow: hidden;

  .chat-desktop-view {
    display: flex;
    flex-grow: 1;
    height: 100%;
    margin-top: 60px;
    width: 100%;
  }

  .chat-mobile-view {
    height: 100vh;
    // margin-top: 60px;
    width: 100%;
  }

  .chat-placeholder {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    color: #999;
    height: 100%;
    border-top: 1px solid #ddd;
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.chat-page {
  .non-active-ra-popup {
    .el-dialog {
      border-radius: 10px;
      width: 480px;

      .title {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 10px;
      }

      .sub-text {
        font-size: 12px;
        color: #696969;
        font-weight: 500;
      }

      .mail {
        font-weight: 600;
        color: #2488ff;
        text-decoration: underline;
      }

      .list {
        width: 250px;
        margin: auto;
        text-align: left;
        margin-top: 20px;

        ul {
          list-style-type: none;
          /* Removes bullet points */
          padding: 0;
          /* Optional: Removes default padding */
          margin: 0;
        }

        li {
          font-size: 12px;
          font-weight: 600;
          padding: 5px 0;

          img {
            position: relative;
            top: 6px;
            margin-right: 5px;
          }
        }
      }
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog--center .el-dialog__body {
      color: #000;
      text-align: center;
    }
  }

  .feedback-popup {
    .network-content {
      padding: 20px 0 !important;
      .refresh-button {
        font-weight: 500;
        color: #2488ff;
        text-decoration: underline;
        margin-top: 10px;
        font-size: 12px;
        cursor: pointer;
      }
      p {
        margin: 0;
      }
      .el-loading-spinner .path {
        stroke: #2488ff !important;
        stroke-width: 6px !important;
      }
    }
    .popup-content {
      padding: 20px 25px;
      text-align: center;

      /* Title Styling */
      .popup-title {
        font-size: 15px;
        font-weight: 700;
        margin-top: 20px;
        color: #000;
        margin-bottom: 0;
      }

      .sub-title {
        margin-top: 7px;
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 30px;
        color: #727272;
      }

      /* Button Group for Category Selection */
      .button-group {
        // display: flex;
        // justify-content: space-between;
        // flex-wrap: wrap;
        margin-bottom: 20px;
        // gap: 20px;
        // justify-content: center;

        .category-btn {
          padding: 12px;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          color: $text-muted;
          font-weight: 600;
          font-size: 13px;
          border: 1px solid transparent;
          width: 150px;
          margin: 10px;
        }

        .no {
          background-color: #fff5f5;
          color: #ea2526;

          &.active {
            border: 1px solid #ea2526;
          }
        }

        .partially {
          background-color: #fff7e3;
          color: #bb8700;

          &.active {
            border: 1px solid #bb8700;
          }
        }

        .yes {
          background-color: #edfff4;
          color: #0ba042;

          &.active {
            border: 1px solid #0ba042;
          }
        }
      }

      .review-options {
        padding: 5px 12px;
        color: #2488ff;
        border: 1px solid #2488ff;
        border-radius: 15px;
        margin: 5px;
        font-weight: 500;
        font-size: 12px;
        cursor: pointer;
        &.selected {
          background-color: #2488ff;
          color: #ffff;
        }
      }

      .agreement-text {
        display: flex;
        text-align: left;
        word-break: normal;

        p {
          margin: 4px 0 0;
          font-size: 10px;
          color: #000;
        }
      }

      /* Chat Button Styling */
      // .chat-btn-container {
      // }
      .chat-btn {
        width: 120px;
        padding: 10px;
        background-color: #2488ff;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s ease;
        margin-top: 20px;
        font-weight: 600;
        font-size: 12px;

        &:disabled {
          cursor: not-allowed;
        }

        &:hover:not(:disabled) {
          background-color: #2488ff;
        }
      }
    }

    .el-dialog {
      width: 630px;
      border-radius: 10px;
      margin-top: 50px !important;
    }

    .el-dialog__header {
      padding: 7px;
      background-color: #2488ff;
      border-radius: 10px 10px 0 0;
    }

    .el-dialog__body {
      padding: 0;
    }

    .close-icon {
      position: absolute;
      right: 7px;
      top: 20px;
      color: #c4c4c4;
    }

    .popup-content {
      .checkbox-group {
        margin-bottom: 20px;
        text-align: left;

        .el-checkbox {
          margin-left: 10px;
        }
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #2488ff;
        border-color: #2488ff;
      }
    }
  }

  .feedback-one {
    .popup-content {
      .yes {
        padding: 18px !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        width: 200px !important;
      }
    }
  }

  .feedback-two {
    .el-dialog {
      width: 450px;
    }
  }

  .chat-ended-popup-outer {
    .feedback-popup {
      .popup-content {
        .popup-title {
          margin-top: 10px;
        }
      }

      .btn-light-blue-filled {
        margin: 30px 0 10px;
      }

      .el-dialog {
        width: 350px;
        margin-top: 130px !important;
      }
    }
  }

  .ra-agreement-popup-outer {
    .feedback-popup {
      .popup-content {
        text-align: left;
        color: #000;

        .popup-title {
          margin: 5px 0 20px;
          font-size: 14px;
        }

        ul {
          padding-left: 20px;
          font-size: 10px;

          li {
            padding: 7px 0;
          }

          span {
            font-weight: 600;
          }
        }

        p {
          font-size: 10px;
          font-weight: 600;
          margin-top: 20px;
        }
      }

      .btn-light-blue-filled {
        margin: 20px 0;
      }

      .el-dialog {
        width: 500px;
      }
    }
  }

  @media screen and (max-width: 670px) {
    .ra-agreement-popup-outer {
      .feedback-popup {
        .el-dialog {
          width: 95%;
        }

        .popup-content {
          padding: 20px 10px;
          .review-options {
            padding: 5px 10px;
            font-size: 10px;
          }

          .button-group {
            margin: 10px 15px;
            .category-btn {
              padding: 10px;
              font-size: 13px;
              border: 1px solid transparent;
              width: 100px;
              margin: 10px;
            }
          }
        }
      }
    }
    .feedback-popup,
    .feedback-two {
      .el-dialog {
        width: 95%;
      }
    }

    .feedback-one {
      .popup-content {
        .yes {
          padding: 12px !important;
          font-weight: 600 !important;
          font-size: 15px !important;
          width: 150px !important;
        }
      }
    }
  }

  @media screen and (max-width: 490px) {
    .feedback-popup .popup-content {
      .button-group {
        .category-btn {
          width: 100%;
        }
      }

      .sub-title {
        font-size: 10px;
      }

      .popup-title {
        font-size: 13px;
      }
    }

    .non-active-ra-popup {
      .el-dialog {
        width: 98%;
      }
    }

    .chat-ended-popup-outer .feedback-popup .el-dialog {
      width: 95%;
      margin-top: 130px !important;
    }

    .feedback-popup {
      .popup-content {
        .button-group {
          margin: 0px;
          margin-top: 25px;
          .category-btn {
            padding: 5px;
            font-size: 10px;
            border: 1px solid transparent;
            width: 70px;
            margin: 0 5px;
            border-radius: 4px;
          }
        }
      }
    }

    .feedback-one {
      .popup-content {
        .yes {
          padding: 8px !important;
          font-weight: 600 !important;
          font-size: 12px !important;
          width: 90px !important;
        }
      }
    }
  }
}
</style>